<template>
  <van-popup
    :value="visible"
    position="bottom"
    get-container="body"
    class="detail-popup"
  >
    <van-nav-bar
      :border="false"
      title="详细信息"
      left-arrow
      @click-left="$emit('update:visible', false)"
    />
    <div class="detail-container">
      <div v-for="(i,key) in baseOptions[type]" :key="key" class="row-box">
        <template v-if="i.constructor===String">
          <div class="text-row">
            <div class="label">
              {{ i }}:
            </div>
            <div class="content">
              {{ agr[key] }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="table-box">
            <div class="title">
              {{ i.title }}
            </div>
            <table v-if="i.table">
              <thead>
                <tr>
                  <th v-for="(j,jKey) in i.table" :key="jKey">
                    {{ j }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(j,index) in agr[key]" :key="index">
                  <td v-for="(k, kKey) in i.table" :key="kKey">
                    {{ j[kKey] }}
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="i.contentKey" class="content">
              {{ agr[i.contentKey] }}
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="tips">
      注：以上部分信息为市场数据采集,仅供参考,不作为任何投资承诺与保证,以此操作风险自担。
    </div>
  </van-popup>
</template>

<script>
import { agrTypeOptions } from '@/constant/common'
import axios from 'axios'

export default {
  name: 'AgrDetail',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    agrData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      baseOptions: {
        'seed': {
          'registration_number': '登记证号',
          'crop_name': '作物名称',
          'variety_name': '品种名称',
          'apply_name': '申请人',
          'breeder_name': '育种者',
          'variety_source': '品种来源',
          'suitable_area_and_season': '适宜种植区域与季节',
          'variety_feature': '特征与特性',
          'culture_technique': '栽培技术要点',
          'attentions': '注意事项'
        },
        'pesticide': {
          'registration_number': '登记证号',
          'pesticide_category': '农药类型',
          'registration_name': '登记名称',
          'virulence': '毒性',
          'dosage_form': '剂型',
          'total_content': '总含量',
          'manufacturers': '生产厂家',
          'start_effective_date': '有效起始日',
          'end_effective_date': '有效截止日',
          'country': '国家',
          'active_ingredient_information': {
            'title': '有效成分信息',
            'table': {
              'active_component': '有效成分',
              'active_ingredient_content': '有效成分含量'
            },
            'contentKey': ''
          },
          'dosage_information_of_the_preparation': {
            'title': '使用技术和使用方法',
            'table': {
              'crop': '作物',
              'prevention_and_treatment_of_the_objec': '防治对象',
              'dosage_of_preparation': '制剂用药量',
              'application_process': '施用方法'
            },
            'contentKey': 'use_memo'
          },
          'product_performance': {
            'title': '产品性能(用途)',
            'contentKey': 'product_performance'
          },
          'cautions': {
            'title': '注意事项',
            'contentKey': 'cautions'
          },
          'poisoning_emergency_rescue': {
            'title': '中毒急救',
            'contentKey': 'poisoning_emergency_rescue'
          },
          'storage_and_transportation': {
            'title': '储存和运输',
            'contentKey': 'storage_and_transportation'
          }
        },
        'fertilizer': {
          'registration_number': '登记证号',
          'goods_name': '产品名称',
          'common_name': '通用名',
          'company_name': '公司名',
          'suitable_crops': '适宜作物',
          'product_form': '产品形态',
          'technical_index': '技术指标'
        },
        'feed': {
          'license_number': '许可证编号',
          'common_name': '通用名称',
          'apply_company': '申请公司',
          'address': '生产厂家及地址',
          'product_name': '制品名称',
          'appearance': '外观',
          'product_class': '产品类别',
          'component': '主要成分',
          'license_type': '许可证类型',
          'is_effict': '是否有效',
          'start_date': '发证日期',
          'end_date': '有效结束日期',
          'use_range': '使用范围和用量',
          'region': '国家/地区',
          'public_number': '公告号',
          'report_number': '检验报告编号'
        },
        'drug': {
          'accepted_number': '受理号',
          'company_name': '企业名称',
          'common_name': '通用名',
          'specification': '规格',
          'goods_name': '商品名',
          'approval_number': '批准文号',
          'approval_day': '批准日期',
          'validity_day': '有效期',
          'failure_cause': '失效原因',
          'change_the_situation': '变更情况'
        }
      },
      agr: {}
    }
  },
  watch: {
    agrData: {
      handler(val) {
        if (agrTypeOptions[this.type].detailApi) {
          axios.get(
            agrTypeOptions[this.type].detailApi,
            { params: { [agrTypeOptions[this.type].detailKey]: val[agrTypeOptions[this.type].detailKey] }}
          ).then(({ data }) => {
            if (data.code === 0) {
              this.agr = data.data
            }
          })
        } else {
          this.agr = val
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.detail-popup {
  height: 100%;
  background: #F6F5F5;
  .van-nav-bar {
    position: sticky;
    top: 0;
  }
}
.detail-container {
  margin: 15px;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(210, 210, 210, 0.7);
}
.text-row {
  border-bottom: 1px solid #ececec;
  font-size: 14px;
  padding: 10px 0;
  > div {
    display: inline-block;
  }
  .label {
    flex-shrink: 0;
    color: #999;
    min-width: 90px;
  }
  .content {
    color: #222;
  }
}
.table-box {
  margin-top: 20px;
  font-size: 12px;
  .title {
    font-weight: 500;
    background: #ECECEC;
    border: 1px solid #bbb;
    border-bottom: none;
    text-align: center;
    padding: 4px;
  }
  table {
    width: 100%;
    text-align: center;
  }
  th {
    background: #ECECEC;
    font-weight: 400;
  }
  th,
  td {
    padding: 4px;
    border: 1px solid #bbb;
  }
  .content {
    border: 1px solid #bbb;
    border-top: none;
    padding: 10px;
    line-height: 1.5;
  }
}
.tips {
  margin: 20px 15px;
  text-align: center;
  font-size: 12px;
  color: #bebebe;
}
</style>
